import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4">
      <Outlet />
    </div>
  )
}
